import {useEffect} from "react";
import {bffApi} from "./bffApi";
import {chatApi} from "./chatApi";
import {getI18nLanguageCode, getLangCodeFromEnum} from "../../types";
import i18n from "../../i18n";

// The stored preference wins over the account language. If the init request
// failed, the account language is used.
export function useApplyUserLanguage() {
    const userData = bffApi.endpoints.getUser.useQuery();
    const initData = chatApi.endpoints.getInit.useQuery({threadCount: 3});

    const brukerKey = userData.data?.brukerKey;
    const spraakId = userData.data?.spraakId;
    const initSettled = initData.isSuccess || initData.isError;
    const preferredLanguage = initData.data?.settings?.preferredLanguage;

    useEffect(() => {
        if (!userData.data || !initSettled) return;

        const target = preferredLanguage
            ? getI18nLanguageCode(preferredLanguage)
            : getLangCodeFromEnum(spraakId);

        if (target !== i18n.resolvedLanguage) {
            i18n.changeLanguage(target);
        }
    }, [brukerKey, spraakId, initSettled, preferredLanguage]);
}
